import {
    CreateListFileModel,
    DeleteExportedFileModel,
    GetCreateListFileApiParameter,
    GetDeleteExportedFileApiParameter,
    getCreateListFile,
    getDeleteExportedFile,
} from "@NA/Services/ADIWishListDetailsExport";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    GetCreateListFileApiParameter & GetDeleteExportedFileApiParameter & HasOnSuccess & HasOnComplete,
    CreateListFileModel & DeleteExportedFileModel
>;

export const CreateExportFile: HandlerType = async (props: any) => {
    props.apiResult = await getCreateListFile({ wishListId: props.parameter.wishListId });
};

export const DownloadExportFile: HandlerType = async (props: any) => {
    // const fileName = props.apiResult.result;
    // const uri = `/Admin/Export/GetFile?file=${fileName}`;
    // window.location.href = uri;
    const fileName = props.apiResult.result;
    const uri = `/api/v1/export/GetFile?file=${fileName}`;

    try {
        const response = await fetch(uri);
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        props.onSuccess?.();
    } catch (error) {
        props.onError?.(error);
    }
};

export const DeleteExportFile: HandlerType = async (props: any) => {
    props.apiResult = await getDeleteExportedFile({ fileName: props.apiResult.result });
};

export const chain = [CreateExportFile, DownloadExportFile, DeleteExportFile];

const getWishListDetailsExportHandler = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        wishListId: "",
        fileName: "",
    },
    "getWishListDetailsExportHandler",
);
export default getWishListDetailsExportHandler;
